<template>
  <div class="navBar">
    <div class="navBar--col navBar--col1">
      <BrandSite/>
    </div>
    <div class="navBar--col navBar--col2">
      <TitleSite/>
    </div>
    <div class="navBar--col navBar--col3">
      <NavMain/>
    </div>
  </div>
</template>

<script>
import BrandSite from '@/components/_BrandSite'
import TitleSite from '@/components/_TitleSite'
import NavMain from '@/components/_NavMain'

export default {
  name: 'NavBar',
  components: {
    BrandSite,
    TitleSite,
    NavMain
  }
}
</script>

<style>

</style>
